// frontend/src/services/adminApi.js
import axios from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000') + '/api';

// Create axios instance with auth
const createAuthAxios = () => {
    const token = localStorage.getItem('popmap_token');

    if (!token) {
        console.error('No token found in localStorage');
    }

    console.log('Creating axios with token:', token ? 'Token exists' : 'No token');

    return axios.create({
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

export const adminApi = {
    // Get dashboard statistics
    getStats: async () => {
        const api = createAuthAxios();
        const response = await api.get('/admin/stats');
        return response.data;
    },

    // Get all users with pagination and search
    getUsers: async (params = {}) => {
        const api = createAuthAxios();
        const { page = 1, limit = 10, search = '', sortBy = 'createdAt', order = 'desc' } = params;
        const response = await api.get('/admin/users', {
            params: { page, limit, search, sortBy, order }
        });
        return response.data;
    },

    // 👇 NEW: Get detailed user information with all maps
    getUserDetails: async (userId) => {
        const api = createAuthAxios();
        const response = await api.get(`/admin/users/${userId}/details`);
        return response.data;
    },

    // Update user (toggle admin or active status, maps limit)
    updateUser: async (userId, updates) => {
        const api = createAuthAxios();
        console.log('Updating user:', userId, 'with:', updates);
        const response = await api.patch(`/admin/users/${userId}`, updates);
        console.log('Update response:', response.data);
        return response.data;
    },

    // Delete user
    deleteUser: async (userId) => {
        const api = createAuthAxios();
        const response = await api.delete(`/admin/users/${userId}`);
        return response.data;
    }
};